<template>
  <footer class="app-footer">
    <!-- Вхід у публічну оферту закладу — вимога LiqPay до сайту мерчанта, п.3.
         router-link, а не href: query з tpayid/menuId має зберегтися, інакше
         navigation guard відправить на loader.

         Знаки платіжних систем тримаємо в цьому ж рядку, а не окремим третім:
         футер видно на кожній сторінці. До «Powered by» їх не ставимо
         навмисно — поруч із назвою Skyservice це читалося б як спільний
         лок-ап, а знаки позначають прийом карток закладом, не нами.
         У кошику знаки вже стоять у панелі оплати, тож там цей не показуємо —
         інакше на одній сторінці вони були б двічі. -->
    <div class="footer-row">
      <router-link
        :to="{ path: '/terms', query: route.query }"
        class="footer-terms"
      >
        Умови користування
      </router-link>
      <CardBrandsMark
        v-if="!isBasket"
        compact
      />
    </div>
    <span class="footer-text">
      Powered by
      <a
        href="https://skyservice.pro"
        target="_blank"
        rel="noopener noreferrer"
        class="footer-link"
      >
        <b>Skyservice POS</b>
      </a>
    </span>
  </footer>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import CardBrandsMark from "@/components/ui/CardBrandsMark.vue";

const route = useRoute();

const isBasket = computed(() => route.path === "/basket");
</script>

<style scoped lang="scss">
.app-footer {
  position: absolute;
  bottom: 10px;
  max-width: 550px;
  width: 100%;
  text-align: center;
  color: var(--text-head);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  /* 16px, більше за внутрішні 8px між самими знаками: інакше посилання й два
     знаки читаються як три однакові елементи, а не як підпис плюс група. */
  .footer-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }

  .footer-terms {
    font-size: 0.75rem;
    color: inherit;
    text-decoration: underline;
    opacity: 0.75;
  }

  .footer-text {
    font-size: 0.875rem;
  }

  .footer-link {
    display: inline;
    color: inherit;
    text-decoration: none;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
